// extracted by mini-css-extract-plugin
export default {"footerCopyRight":"footer_footerCopyRight__r9GDz"};